<section class="activity-feed" [attr.aria-labelledby]="headingId">
  <to-section-title
    [headingId]="headingId"
    [title]="'liveDashboard.activity.title' | translate"
    [subtitle]="'liveDashboard.activity.subtitle' | translate"
  >
    <span
      right
      class="activity-feed__history activity-feed__history--disabled"
      aria-disabled="true"
      [title]="'liveDashboard.activity.comingSoon' | translate"
    >
      {{ 'liveDashboard.activity.fullHistory' | translate }}
      <mat-icon aria-hidden="true">chevron_right</mat-icon>
    </span>
  </to-section-title>

  <ol class="activity-feed__list">
    @for (entry of activity(); track entry.id) {
      <li class="activity-feed__item">
        <app-activity-entry [item]="entry" />
      </li>
    }
  </ol>
</section>
